var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "199AB957-394A-45C5-B952-9180EC32992D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1000,
    height: 396,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.9%",
    width: "102.1%",
    height: "105.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.25   0 0 0 0 0.375   0 0 0 0 0.5  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 320,
    height: 378,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.3%",
    y: "-2.0%",
    width: "106.6%",
    height: "105.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.25   0 0 0 0 0.375   0 0 0 0 0.5  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M\\u0101c\\u012Bbu-grupas---Atv\\u0113rums-(Pabeigt-komplekt\\u0113\\u0161anu)",
    transform: "translate(-629.000000, -89.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F0F2F5",
    x: 0,
    y: 0,
    width: 1280,
    height: 800
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-content",
    transform: "translate(260.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#CED4D9",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 999,
    height: 395,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(30.000000, 30.000000)",
    fill: "#515C66",
    fontFamily: "Inter-Medium, Inter",
    fontSize: 11,
    fontWeight: 400,
    letterSpacing: -0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks",
    transform: "translate(58.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Col-3",
    transform: "translate(280.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Status:"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "Status:")))))), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    fill: "#303136",
    opacity: 0.600000024,
    x: 0,
    y: 0,
    width: 1280,
    height: 800
  }), /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(480.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(30.000000, 30.000000)",
    fill: "#0883EF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(100.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fillOpacity: 0.1,
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.000000, 19.000000)",
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0 C12.0376892,0 12.8789024,0.841213277 12.8789024,1.87890244 L12.8752434,1.99610516 L12.0623783,15.0019474 C12.0273156,15.5629504 11.5620976,16 11,16 C10.4379024,16 9.9726844,15.5629504 9.93762171,15.0019474 L9.12475657,1.99610516 C9.0600273,0.96043681 9.84712894,0.0683882868 10.8827973,0.00365901505 C10.9218173,0.00122026577 10.9609039,0 11,0 Z M11,22 C12.1045695,22 13,21.1045695 13,20 C13,18.8954305 12.1045695,18 11,18 C9.8954305,18 9,18.8954305 9,20 C9,21.1045695 9.8954305,22 11,22 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.e51301a0984b0d50f76a9982d4aa5536.svg";
export { ForwardRef as ReactComponent };